import './Legal.css';

export default function Cookies() {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1>Cookie Policy</h1>
                <p className="last-updated">Last updated: December 2024</p>

                <section>
                    <h2>What Are Cookies</h2>
                    <p>Cookies are small text files stored on your device when you visit a website. They help websites remember your preferences and improve your experience.</p>
                </section>

                <section>
                    <h2>How We Use Cookies</h2>
                    <p>autopsyURL uses cookies for:</p>
                    <ul>
                        <li><strong>Essential cookies</strong> - Required for the service to function properly</li>
                        <li><strong>Preference cookies</strong> - Remember your settings and preferences</li>
                        <li><strong>Analytics cookies</strong> - Help us understand how visitors use our site</li>
                    </ul>
                </section>

                <section>
                    <h2>Types of Cookies We Use</h2>
                    <table className="cookie-table">
                        <thead>
                            <tr>
                                <th>Cookie</th>
                                <th>Purpose</th>
                                <th>Duration</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>session_id</td>
                                <td>Maintains your session</td>
                                <td>Session</td>
                            </tr>
                            <tr>
                                <td>preferences</td>
                                <td>Stores your preferences</td>
                                <td>1 year</td>
                            </tr>
                        </tbody>
                    </table>
                </section>

                <section>
                    <h2>Managing Cookies</h2>
                    <p>You can control cookies through your browser settings. Note that disabling cookies may affect service functionality.</p>
                    <p>Most browsers allow you to:</p>
                    <ul>
                        <li>View cookies stored on your device</li>
                        <li>Delete all or specific cookies</li>
                        <li>Block cookies from specific sites</li>
                        <li>Block all cookies</li>
                    </ul>
                </section>

                <section>
                    <h2>Third-Party Cookies</h2>
                    <p>We may use third-party services that set their own cookies. These are governed by the respective third-party privacy policies.</p>
                </section>

                <section>
                    <h2>Contact</h2>
                    <p>For questions about our cookie policy, contact us at privacy@autopsyurl.com</p>
                </section>
            </div>
        </div>
    );
}
